import { CurrencyPipe } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { formatCurrency, FormatDateISO } from '@webapp/core';
import { IQuoteWithInsurable } from '../../../interfaces/quotes.interface';
import { QuotesStoreService } from '../../../store/quotes-store.service';

@Component({
  selector: 'app-quote-info',
  imports: [],
  providers: [CurrencyPipe],
  templateUrl: './quote-info.component.html',
  styleUrl: './quote-info.component.scss',
})
export class QuoteInfoComponent {
  quotesStore = inject(QuotesStoreService);
  currencyPipe = inject(CurrencyPipe);

  quoteInfo = computed(() => {
    const quote = this.quotesStore.get()();
    return quote ? this.parseQuote(quote) : [];
  });

  parseQuote(quote: IQuoteWithInsurable): [string, string][] {
    if (quote.vehicleInsurable) {
      return this.parseVehicleInsurable(quote.vehicleInsurable, quote.currency);
    }

    if (quote.personalAccidentInsurable) {
      return this.parsePersonalAccidentInsurable(quote.personalAccidentInsurable);
    }

    if (quote.transportationGoodsInsurable) {
      return this.parseTransportationGoodsInsurable(quote.transportationGoodsInsurable, quote.currency);
    }

    return [];
  }

  parseVehicleInsurable(vehicle: IQuoteWithInsurable['vehicleInsurable'], currency: string): [string, string][] {
    if (!vehicle) return [];
    const { brand, model, year, sumInsured, } = vehicle;
    return [
      ['Marca', brand],
      ['Modelo', model],
      ['Año', year.toString()],
      ['Suma Asegurada', formatCurrency(sumInsured, currency)],
    ];
  }

  parsePersonalAccidentInsurable(accident: IQuoteWithInsurable['personalAccidentInsurable']): [string, string][] {
    if (!accident) return [];

    const { activity, startDate, endDate, numberOfLifes } = accident;

    return [
      ['Actividad', activity],
      ['Vigencia', `${this.parseDate(startDate)} - ${this.parseDate(endDate)}`],
      ['Cantidad de vidas', numberOfLifes.toString()],
    ];
  }

  parseTransportationGoodsInsurable(
    goodsInsurable: IQuoteWithInsurable['transportationGoodsInsurable'],
    currency: string
  ): [string, string][] {
    if (!goodsInsurable) return [];
    const { goods, sumInsured, placeOfDestination, placeOfOrigin, usedGoods } = goodsInsurable;
    const formattedAmount = formatCurrency(sumInsured, currency);
    
    return [
      ['Mercadería', goods],
      ['Usado', (usedGoods) ? 'Si' : 'No'],
      ['Desde', placeOfOrigin],
      ['Hasta', placeOfDestination],
      ['Suma Asegurada', formattedAmount],
    ];
  }

  
  parseDate(date: Date): string {
    return FormatDateISO(new Date(date)).split('-').reverse().join('/');
  }
}